var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable react/require-default-props */
import React, { useState, useEffect, useRef } from 'react';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import VisibilityToggle from './VisibilityToggle';
import useNotesMutations from '../hooks/useNotesMutations';
const namespace = 'features.activity_feed.note_form';
export default function NoteForm({ buildingId, workOrderId, inspectionId, deficiencyId }) {
    const [notes, setNotes] = useState('');
    const [visibility, setVisibility] = useState('tech');
    const noteRef = useRef(null);
    const { createNote } = useNotesMutations({ buildingId, inspectionId, workOrderId, deficiencyId });
    useEffect(() => {
        const handleClick = (event) => {
            if (noteRef.current && !noteRef.current.contains(event.target)) {
                removeActive();
            }
        };
        const handleFocus = (event) => {
            if (noteRef.current && !noteRef.current.contains(event.target)) {
                removeActive();
            }
        };
        document.addEventListener('mousedown', handleClick);
        document.addEventListener('focusin', handleFocus);
        return () => {
            document.removeEventListener('mousedown', handleClick);
            document.removeEventListener('focusin', handleFocus);
        };
    }, []);
    const addActive = () => {
        if (noteRef.current) {
            noteRef.current.classList.add('--active');
        }
    };
    const removeActive = () => {
        if (noteRef.current) {
            noteRef.current.classList.remove('--active');
        }
    };
    const onSubmit = (e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        try {
            yield createNote({ buildingId, inspectionId, workOrderId, notes, visibility });
            setNotes('');
            removeActive();
            if (noteRef.current) {
                noteRef.current.children[0].style.height = '118px';
            }
        }
        catch (error) {
            toast.error('There was an error creating the note');
        }
    });
    const onVisibilityChange = (newVisibility) => {
        setVisibility(newVisibility);
    };
    return (React.createElement("form", { onSubmit: (e) => {
            void onSubmit(e);
        } },
        React.createElement("div", { className: "qmb-textarea--note--x-full", ref: noteRef },
            React.createElement("textarea", { value: notes, onChange: (e) => {
                    setNotes(e.target.value);
                }, name: "notes", placeholder: " ", id: "activity_notes", onFocus: addActive }),
            React.createElement("label", { className: "qmb-label", htmlFor: "activity_notes" }, translate('add_note', { namespace })),
            React.createElement("div", { className: "textarea__controls" },
                React.createElement(VisibilityToggle, { note: {
                        id: 0,
                        buildingId,
                        notes: '',
                        visibility,
                        canEditVisibilityDestroy: true,
                        inspectionId,
                        workOrderId
                    }, onVisibilityChange: onVisibilityChange }),
                React.createElement("button", { disabled: notes.length === 0, type: "submit", className: "qmb-control--submit" }, translate('submit', { namespace: 'features.commons' }))),
            React.createElement("svg", { viewBox: "0 0 32 32", className: "textarea__accent" },
                React.createElement("path", { d: "M 32 0 L 0 32", className: "accent__diag" }),
                React.createElement("path", { d: "M 26 0.5 L 0 0.5", className: "accent__x" }),
                React.createElement("path", { d: "M 0.5 26 L 0.5 0", className: "accent__y" })))));
}
